import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Claim169CardGenerator from './pages/Claim169CardGenerator';
import Settings from './pages/Settings';

// Get base path from environment or window.env, default to empty (root)
const getBasePath = (): string => {
  const envBasePath = process.env.REACT_APP_BASE_PATH || window.env?.REACT_APP_BASE_PATH || '';
  // Ensure base path starts with / and doesn't end with /
  if (envBasePath && envBasePath !== '') {
    return envBasePath.startsWith('/') ? envBasePath : `/${envBasePath}`;
  }
  return '';
};

const App: React.FC = () => {
  const basePath = getBasePath();
  
  return (
    <Router basename={basePath}>
      <Switch>
        <Route path="/settings" component={Settings} />
        <Route path="/" component={Claim169CardGenerator} />
      </Switch>
    </Router>
  );
};

export default App;